export const BASE_SETTINGS_PATH = '/client/settings';
export const CREATE_EMPLOYEE_PATH = '/employee/new';
export const EDIT_EMPLOYEE_PATH = '/employee/:id/edit';
export const editEmployeePathById = (employeeId: number) => `/employee/${employeeId}/edit`;

export const EMPLOYEES_ACCOUNTS_PAGE = '/organization/employeesAccounts';
